import { render, staticRenderFns } from "./cancelForm.vue?vue&type=template&id=85f825d4&"
import script from "./cancelForm.vue?vue&type=script&lang=js&"
export * from "./cancelForm.vue?vue&type=script&lang=js&"
import style0 from "./cancelForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports